// import React, { Component, useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import { Form } from 'react-bootstrap';
// import { useLocation, useHistory } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { useDispatch, useSelector } from 'react-redux';
// import { isEmpty } from '../../lib/common';
// import * as adminFunctions from '../../axioscalls/admin.js';
// import { Account_Connect, Account_disConnect, Initial_Connect, Admin_Login } from "../../redux/action.js";
// import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';

// toast.configure();


// export default function Login(props) {

//   // var location = useLocation();
//   const history = useHistory();
//   const dispatch = useDispatch();

//   const Wallet_Details = useSelector((state) => state.wallet_detail)

//   useEffect(() => {
//     console.log("Props : ", props.data)
//     console.log("admin_login", Wallet_Details.Login_Admin)
//     if (localStorage.getItem("adminlogin") == "yes") {
//       history.push("/dashboard");
//     }
//   }, [Wallet_Details.userAccountAddr])


//   const initialValue = {
//     "email": "",
//     "password": ""
//   }


//   const [formValue, setFormValue] = useState(initialValue);
//   const [validErrors, setValidErrors] = useState("");
//   const [loc, setLoc] = useState("")


//   const formvalidation = async (data) => {
//     console.log("i/p for validaion", data)

//     var validationErr = {};
//     let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([A-Za-zA-Z\-0-9]+\.)+[A-Za-zA-Z]{2,}))$/;

//     if (data.email == "") { validationErr.email = "Email cannot be empty" }
//     else if (data.email != "") {
//       if (!emailRegex.test(data.email)) { validationErr.email = "Enter valid email" }
//     }

//     if (!data.password) { validationErr.password = "password cannot be empty" }

//     console.log("validation object", validationErr)
//     return validationErr;

//   }




//   const handleSubmit = async () => {
//    var data={ "email":formValue.email,
//    "password": passwordInput}
//     var resp = await formvalidation(data);

//     if (resp) setValidErrors(resp)
//     if (!isEmpty(resp)) {
//       console.log("erore", isEmpty(resp))   // shiuld add toastr here

//     }
//     else {
//       data.path = "login";
//       var resp = await adminFunctions.loginAdmin(data);
//       console.log('resppppp', resp)

//       if(resp.status ){
//         if (resp.data) {

//           localStorage.setItem("adminlogin", "yes")
//           localStorage.setItem("token", resp.token)

//           toast.success(resp.message)
//           history.push("/bloglist");
//         }
//       }

//       else {
//         toast.error(resp.message)
//       }

//     }


//   }


//   const handlechange = (e) => {

//     const { id, value } = e.target;
//     setFormValue({ ...formValue, [id]: value })

//   }






//   const [passwordType, setPasswordType] = useState("password");
//   const [passwordInput, setPasswordInput] = useState("");
//   const handlePasswordChange = (evnt) => {
//     setPasswordInput(evnt.target.value);
//   }
//   const togglePassword = () => {
//     if (passwordType === "password") {
//       setPasswordType("text")
//       return;
//     }
//     setPasswordType("password")
//   }



//   return (
//     <div>
//       <div className="d-flex align-items-center justify-content-center auth ">
//         <div className="row">
//           <div className="col-lg-4">
//             <div className="card text-left logincard">
//               <div className="brand-logo">
//                 <img src={require("../../assets/images/logos.png")} alt="logo" />
//               </div>
//               <h4>Hello! let's get started</h4>
//               <h6 className="font-weight-light">Sign in to continue.</h6>
//               <Form className="pt-3">
//                 <Form.Group className="d-flex search-field mb-2">
//                   <Form.Control type="email" placeholder="Enter email" size="lg" className="h-auto" id="email" value={formValue.email} onChange={(e) => handlechange(e)} />
//                 </Form.Group>
//                 <p className='redclr'> {validErrors.email}</p>

//                 <div className="input-group passwordinput mb-2">
//                   <input type={passwordType} onChange={(e)=>handlePasswordChange(e)} value={passwordInput} name="password" class="form-control pw" placeholder="Enter Password" />
//                   <div className="input-group-btn">
//                     <button className="btn btn-outline-primary eyebtns" type="button" onClick={()=>togglePassword()}>
//                       {passwordType === "password" ? <AiFillEye /> : <AiFillEyeInvisible />}
//                     </button>
//                   </div>
//                 </div>

//                 <p className='redclr'>{validErrors.password}</p>
//                 <div className="mt-3">
//                   <p className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn allbtn allbtns" onClick={() => handleSubmit()}>SIGN IN</p>
//                 </div>
//         <span class="d-flex justify-content-end forgotpassword"> Forgot Password ?</span>

//               </Form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )

// }

import React, { Component, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { formatTime, isEmpty } from '../../lib/common';
import * as adminFunctions from '../../axioscalls/admin.js';
import { Account_Connect, Account_disConnect, Initial_Connect, Admin_Login } from "../../redux/action.js";
import { AiFillEye, AiFillEyeInvisible, AiOutlineClose } from 'react-icons/ai';
import { Modal, Button, Card, Row, Col } from "react-bootstrap";

toast.configure();


export default function Login(props) {
  console.log("Login Page");
  
  // var location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const Wallet_Details = useSelector((state) => state.wallet_detail)
  const [canResend, setCanResend] = useState(false)
  const [canReset, setCanReset] = useState(true)
  const [timer, setTimer] = useState(300);
  const [validErrors, setValidErrors] = useState("");
  const [error, setError] = useState({});
  const [newPasswordType, setNewPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  useEffect(() => {
    console.log("Props : ", props.data)
    console.log("admin_login", Wallet_Details.Login_Admin)
    if (localStorage.getItem("adminlogin") == "yes") {
      history.push("/dashboard");
    }
  }, [Wallet_Details.userAccountAddr])
  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [timer]);
  const initialValue = {
    "email": "",
    "password": "",
    "newPassword": "",
    "confirmNewPassword": "",
    "otp": "",
  }
  const [loc, setLoc] = useState("")
  const [formValue, setFormValue] = useState(initialValue);
  const formvalidation = async (data) => {
    console.log("i/p for validaion", data)
    var validationErr = {};
    let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([A-Za-zA-Z\-0-9]+\.)+[A-Za-zA-Z]{2,}))$/;
    if (data.email == "") { validationErr.email = "Email cannot be empty" }
    else if (data.email != "") {
      if (!emailRegex.test(data.email)) { validationErr.email = "Enter valid email" }
    }
    if (!data.password) { validationErr.password = "password cannot be empty" }
    console.log("validation object", validationErr)
    return validationErr;
  }

  const handleSubmit = async () => {
    var data = {
      "email": formValue.email,
      "password": passwordInput
    }
    var resp = await formvalidation(data);
    if (resp) setValidErrors(resp)
    if (!isEmpty(resp)) {
      console.log("erore", isEmpty(resp))   // shiuld add toastr here
    }
    else {
      data.path = "login";
      var resp = await adminFunctions.loginAdmin(data);
      console.log('resppppp', resp)
      if (resp.status) {
        if (resp.data) {
          localStorage.setItem("adminlogin", "yes")
          localStorage.setItem("token", resp.token)
          toast.success(resp.message)
          history.push("/bloglist");
          setTimer(300);
        }
      }
      else {
        toast.error(resp.message)
        setTimer(0);
      }
    }
  }

  const handlechange = (e) => {
    const { id, value } = e.target;
    setFormValue({ ...formValue, [id]: value })
  }

  const [passwordType, setPasswordType] = useState("password");
  const [passwordInput, setPasswordInput] = useState("");
  const handlePasswordChange = (evnt) => {
    setPasswordInput(evnt.target.value);
  }
  const sendResendLink = async () => {
    if (!formValue.email) {
      setError({ email: "Email cannot be empty" })
      return;
    }
    var response = await adminFunctions.sendResetLink({ email: formValue?.email });
    console.log('sendResendLink_response : ', response)
    if (response.status) {
      toast.success(response.message)
      setResetModal(true);
      setViewopen(false);
      setCanResend(false);
    }
    else {
      toast.error(response.message)
      setResetModal(false);
      setViewopen(true);
      setCanReset(true);
    }
  }
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text")
      return;
    }
    setPasswordType("password")
  }

  const toggleNewPassword = () => {
    if (newPasswordType === "password") {
      setNewPasswordType("text")
      return;
    }
    setNewPasswordType("password")
  }

  const toggleConfirmPassword = () => {
    if (confirmPasswordType === "password") {
      setConfirmPasswordType("text")
      return;
    }
    setConfirmPasswordType("password")
  }

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/[^0-9]/g, ""); // numbers only
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1); // take only last digit
    setOtp(newOtp);

    // Auto-focus next box
    if (index < 5) {
      document.getElementById(`otp_${index + 1}`).focus();
    }
  };

  const handleOtpKeyDown = (e, index) => {
    // On backspace, clear current and focus previous
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
      if (index > 0) {
        document.getElementById(`otp_${index - 1}`).focus();
      }
    }
  };

  const handleOtpPaste = (e) => {
    const pasted = e.clipboardData.getData("text").replace(/[^0-9]/g, "").slice(0, 6);
    if (pasted.length === 6) {
      setOtp(pasted.split(""));
      document.getElementById(`otp_5`).focus();
    }
    e.preventDefault();
  };

  const handleReset = async () => {
    let hasError = false;
    const otpString = otp.join("");

    // Validate all fields first
    if (!otpString) {
      setError(prev => ({ ...prev, otp: "OTP is required" }));
      hasError = true;
    } else if (otpString.length < 6) {
      setError(prev => ({ ...prev, otp: "OTP should be 6 digits" }));
      hasError = true;
    }

    if (!formValue.newPassword) {
      setError(prev => ({ ...prev, newPassword: "Password is required" }));
      hasError = true;
    }

    if (!formValue.confirmNewPassword) {
      setError(prev => ({ ...prev, confirmNewPassword: "Confirm Password is required" }));
      hasError = true;
    } else if (formValue.newPassword !== formValue.confirmNewPassword) {
      setError(prev => ({ ...prev, confirmNewPassword: "Passwords do not match" }));
      hasError = true;
    }

    if (hasError) return;

    const response = await adminFunctions.resetPassword({
      otp: otpString,
      newPassword: formValue.newPassword,
      email: formValue.email,
      confirmNewPassword: formValue.confirmNewPassword,
    });

    if (response.status) {
      toast.success(response.message);
      setResetModal(false);
      setFormValue(initialValue);
    } else {
      toast.error(response.message);
    }
  };

  const [viewopen, setViewopen] = useState(false);
  const [resetModal, setResetModal] = useState(false);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-center auth ">
        <div className="row">
          <div className="col-lg-4">
            <div className="card text-left logincard">
              <div className="brand-logo">
                <img src={require("../../assets/images/logos.png")} alt="logo" />
              </div>
              <h4>Hello! let's get started</h4>
              <h6 className="font-weight-light">Sign in to continue.</h6>
              <Form className="pt-3">
                <Form.Group className="d-flex search-field mb-2">
                  <Form.Control type="email" placeholder="Enter email" size="lg" className="h-auto" id="email" value={formValue.email} onChange={(e) => handlechange(e)} />
                </Form.Group>
                <p className='redclr'> {validErrors.email}</p>

                <div className="input-group passwordinput mb-2">
                  <input type={passwordType} onChange={(e) => handlePasswordChange(e)} value={passwordInput} name="password" class="form-control pw" placeholder="Enter Password" />
                  <div className="input-group-btn">
                    <button className="btn btn-outline-primary eyebtns" type="button" onClick={() => togglePassword()}>
                      {passwordType === "password" ? <AiFillEye /> : <AiFillEyeInvisible />}
                    </button>
                  </div>
                </div>

                <p className='redclr'>{validErrors.password}</p>
                <div className="mt-3">
                  <p className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn allbtn allbtns" onClick={() => handleSubmit()}>SIGN IN</p>
                </div>
                <span class="d-flex justify-content-end forgotpassword" onClick={() => setViewopen(true)}> Forgot Password ?</span>

              </Form>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={viewopen}
        onHide={() => setViewopen(false)}
        centered
        size="md"
      >
        <Modal.Body className="forgot_modal_body">
          {/* <button
            onClick={() => setViewopen(false)}
            className="forgot_close_btn"
          >x</button> */}
          <AiOutlineClose className="forgot_close_btn" onClick={() => setViewopen(false)} />
          <h3 className="forgot_title">Forgot Password</h3>

          <div className="forgot_icon">🔐</div>

          <div className="forgot_input_wrapper">
            <div className="forgot_input_icon">✉</div>

            <Form.Control
              type="email"
              placeholder="Enter Email Address"
              className="forgot_input"
              id="email"
              value={formValue.email}
              onChange={(e) => { handlechange(e); setError({ ...error, email: "" }) }}
            />
          </div>
          <span className="error_msg">{error.email}</span>

          <p className="forgot_text">
            Enter Email Address to{" "}
            <span>Reset The Password</span>
          </p>

          <div className="forgot_btn_group">
            <Button
              onClick={() => { setViewopen(false); setFormValue({ ...formValue, email: '' }); setError({ ...error, email: "" }); setCanReset(true); }}
              className="forgot_back_btn"
            >
              Back to Login
            </Button>

            <Button
              className="forgot_submit_btn"
              disabled={!canReset}
              onClick={() => {
                sendResendLink();
                setCanReset(false);
              }}
            >
              Send OTP
            </Button>
          </div>

        </Modal.Body>
      </Modal>
      <Modal
        show={resetModal}
        onHide={() => setResetModal(false)}
        centered
        className="otp_modal"
      >
        <Modal.Body className="otp_modal_body">

          {/* Close Button */}
          {/* <button
            onClick={() => setResetModal(false)}
            className="forgot_close_btn"
          >x</button> */}
          <AiOutlineClose className="forgot_close_btn" onClick={() => { setResetModal(false); setCanReset(true); }} />
          {/* Title */}
          <h2 className="otp_title">OTP Verification</h2>

          {/* OTP Label */}
          <p className="otp_label">Enter OTP</p>

          {/* OTP Inputs */}
          <div className="otp_inputs">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp_${index}`}
                type="text"
                maxLength={1}
                className="otp_box"
                value={digit}
                onChange={(e) => handleOtpChange(e, index)}
                onKeyDown={(e) => handleOtpKeyDown(e, index)}
                onPaste={handleOtpPaste}
              />
            ))}
          </div>
          <span className="error_msg">{error.otp}</span>

          {/* Resend */}
          {!canResend ? (
            <p className="otp_resend">
              Resend OTP in <span>{(formatTime(timer))}</span>
            </p>
          ) : (
            <Button className="forgot_submit_btn" onClick={() => sendResendLink()}>
              Resend OTP
            </Button>
          )}


          {/* Password */}
          <div className="password_group">
            <label className="password_label">New Password</label>
            <div className="input-group passwordinput mb-2">
              <input type={newPasswordType} onChange={(e) => { setFormValue({ ...formValue, newPassword: e.target.value }); setError(prev => ({ ...prev, newPassword: "" })); }} value={formValue.newPassword} name="newPassword" class="form-control pw" placeholder="Enter New Password" />
              <div className="input-group-btn">
                <button className="btn btn-outline-primary eyebtns" type="button" onClick={() => toggleNewPassword()}>
                  {newPasswordType === "password" ? <AiFillEye /> : <AiFillEyeInvisible />}
                </button>
              </div>
            </div>
            <span className="error_msg">{error.newPassword}</span>

            {/* <div className="password_input_wrapper">
              <Form.Control
                type="password"
                placeholder="Enter New Password"
                className="password_input"
                id="newPassword"
                value={formValue.newPassword}
                onChange={(e) => setFormValue({ ...formValue, newPassword: e.target.value })}
              />

              <span className="password_eye">
                <i className="fa-regular fa-eye-slash"></i>
              </span>
            </div> */}
          </div>

          {/* Confirm Password */}
          <div className="password_group">
            <label className="password_label">
              Confirm New Password
            </label>
            <div className="input-group passwordinput mb-2">
              <input type={confirmPasswordType} onChange={(e) => { setFormValue({ ...formValue, confirmNewPassword: e.target.value }); setError(prev => ({ ...prev, confirmNewPassword: "" })); }} value={formValue.confirmNewPassword} name="confirmNewPassword" class="form-control pw" placeholder="Confirm New Password" />
              <div className="input-group-btn">
                <button className="btn btn-outline-primary eyebtns" type="button" onClick={() => toggleConfirmPassword()}>
                  {confirmPasswordType === "password" ? <AiFillEye /> : <AiFillEyeInvisible />}
                </button>
              </div>
            </div>
            <span className="error_msg">{error.confirmNewPassword}</span>
            {/* <div className="password_input_wrapper">
              <Form.Control
                type="password"
                placeholder="Confirm New Password"
                className="password_input"
                id="confirmNewPassword"
                value={formValue.confirmNewPassword}
                onChange={(e) => setFormValue({ ...formValue, confirmNewPassword: e.target.value })}
              />

              <span className="password_eye">
                <i className="fa-regular fa-eye-slash"></i>
              </span>
            </div> */}
          </div>

          {/* Submit */}
          <Button className="forgot_submit_btn" onClick={() => handleReset()}>
            Submit
          </Button>

          {/* Footer */}
          <p className="copyright_text">
            Copy right © 2026, Galfi All rights reserved
          </p>

        </Modal.Body>
      </Modal>
    </div>
  )

}
